import { httpClient } from '../Common/api/http_client';

// eslint-disable-next-line no-return-await
const service = {
  async fetchTotals() {
    return httpClient.get('/reports/dashboard/totals');
  },

  async fetchCustomers() {
    return httpClient.get('/reports/dashboard/newcustomers');
  },

  async fetchSalesHistory() {
    return httpClient.get('/reports/dashboard/saleshistory');
  },

  async fetchYearEarnings() {
    return httpClient.get('/reports/dashboard/yearearnings');
  },

  async fetchMonthEarnings() {
    return httpClient.get('/reports/dashboard/monthearnings');
  },

  async fetchWeekEarnings() {
    return httpClient.get('/reports/dashboard/weekearnings');
  },

  async fetchTotalOrders() {
    return httpClient.get('/reports/dashboard/yearorders');
  },

  async fetchUploadedProducts() {
    return httpClient.get('/reports/dashboard/productsuploaded');
  },

  async fetchSalesByLocation() {
    return httpClient.get('/reports/dashboard/locationsales');
  },

  async fetchProductSales() {
    return httpClient.get('/reports/dashboard/productsold');
  },

  async fetchDataForTopRegions() {
    return httpClient.get('/reports/dashboard/topregions');
  },
};

export default service;
